import { ChatRoomContextSchemaData, UserContextSchemaData } from '../schema'
import { schemaPath } from '../schema/types'
import { trackEvent } from './helper'

export const open_chat = ({
  data,
  ...props
}: {
  data: {
    /**
     * Chat Room id of the opend chat room
     */
    chat_id: number
    /**
     * The Boolean indicate if this user is the owner of chat room or not.
     */
    is_owner: boolean
    /**
     * Number of unread notification when user opens chat room. 0 if no unread message.
     */
    unread_count: number
  }
  user: UserContextSchemaData
  chatRoom: ChatRoomContextSchemaData
}) => {
  trackEvent({
    event: {
      schema: schemaPath({
        vendor: 'space.yay',
        name: 'open_chat',
        format: 'jsonschema',
        version: '1-0-0',
      }),
      data,
    },
    ...props,
  })
}

export const send_message = (data: {
  /**
   * Type of message
   */
  type: 'text' | 'image' | 'video' | 'gif' | 'sticker' | 'system_message'
}) => {
  trackEvent({
    event: {
      schema: schemaPath({
        vendor: 'space.yay',
        name: 'send_message',
        format: 'jsonschema',
        version: '1-0-0',
      }),
      data,
    },
  })
}

export const create_chat_call = (props: { user: UserContextSchemaData }) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'create_call',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const delete_chat = (props: {
  user: UserContextSchemaData
  chatRoom: ChatRoomContextSchemaData
}) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'delete_chat',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}
